import React, { Component, useRef, useMemo, useState, useEffect } from "react";
import ReactTableComponent from "../Table/ReactTablecomponent";
import { Link, useLocation, useHistory } from "react-router-dom";
import moment from "moment";
import NoteModal from "./NoteModal";
import Joi from "joi";
import { joiResolver } from "@hookform/resolvers/joi";
import { useForm } from "react-hook-form";
import { name, phone, email, date, gender, first_name, last_name, place } from "../../utils/validations";
import cx from "classnames";
import InputField from "../Form/InputField";
import PhoneField from "../Form/PhoneField";
import SelectField from "../Form/SelectField";
import RadioField from "../Form/RadioField";
import { makeStyles } from '@material-ui/core/styles';
import CountryStates from "../../public/country-states.json";
import CountryCodes from "../../public/country-phone";
import { getToken } from "../../utils/common";
import Button from "../Button/Button"
import TwinWhite from '../../assets/icons/twin-beds-white.png'
import TwinPurple from '../../assets/icons/twin-beds-purple.png'
import DoubleWhite from '../../assets/icons/bed-white.png'
import DoublePurple from '../../assets/icons/bed-purple.png'
import ReactLoading from 'react-loading';
import styles from "./leads.module.css"

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: "#500E4B",
        color: '#fff',
        justifyContent: 'center'
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
    },
    tabPanel: {
        width: '80%'
    },
    textField: {
        width: '90%'
    },
    tab: {

    },
    ul: {
        "& .MuiPaginationItem-root": {
            backgroundColor: "#500E4B",
            color: '#fff'
        }
    }
}));

export default function LeadDetails({ dataTable, i, editableStatus, isInternational }) {

    const classes = useStyles();
    const [guetsCount, setGuestCount] = useState(dataTable[i].guest.length > 0 ? dataTable[i].guest.length : 1)
    const [bedSelection, setBedSelection] = useState(dataTable[i].bedSelection != null ? dataTable[i].bedSelection : "twin_bed")
    const [loader, setLoader] = useState(false)

    const bedsArray = Array(dataTable[i].guests_count).fill({});

    const joiObject = {};

    const referenceDate = new Date();

    const adultMaxDate = new Date(
        new Date(referenceDate).setMonth(referenceDate.getMonth() - 0)
    );

    const firstAdultMaxDate = new Date(
        new Date(referenceDate).setMonth(referenceDate.getMonth() - 18 * 12)
    );

    const childMaxDate = new Date(
        new Date(referenceDate).setMonth(referenceDate.getMonth() - 2 * 12)
    );

    const infantMaxDate = new Date(
        new Date(referenceDate).setMonth(referenceDate.getMonth() - 6)
    );


    dataTable[i].rooms.forEach((room, roomIndex) => {
        const count = guetsCount;
        for (let guestIndex = 0; guestIndex < count; guestIndex++) {
            const prefix = `${roomIndex}_${guestIndex}`;
            joiObject[`${prefix}_first_name`] = first_name;
            joiObject[`${prefix}_last_name`] = last_name;
            joiObject[`${prefix}_meal`] = name;
            joiObject[`${prefix}_gender`] = gender;
            joiObject[`${prefix}_dob`] = date.max(adultMaxDate)
            joiObject[`${prefix}_country`] = name;
            joiObject[`${prefix}_state`] = name;
            joiObject[`${prefix}_phone`] = phone;
            joiObject[`${prefix}_email`] = email;
            joiObject[`${prefix}_personalid`] = name;
            joiObject[`${prefix}_proof`] = name;
            joiObject[`${prefix}_webCheckinDocPlace`] = Joi.string().allow('');
            joiObject[`${prefix}_webCheckinDocDate`] = Joi.date().allow('');
            if (isInternational) {
                joiObject[`${prefix}_passportIssueDate`] = date;
                joiObject[`${prefix}_passportExpiryDate`] = date;
                joiObject[`${prefix}_passportNumber`] = name;
                joiObject[`${prefix}_passportAddress`] = name;
            }
        }
    })

    const { register, errors, handleSubmit, setError, watch } = useForm({
        resolver: joiResolver(Joi.object(joiObject)),
    });

    const onSubmit = (data) => {
        setLoader(true)
        console.log('data', data)
        const newRooms = [...dataTable[i].rooms].map((room) =>
            Object.assign({}, room, {
                guests: [...(room.guests || [])].map((guest) =>
                    Object.assign({}, guest)
                ),
            })
        );
        Object.keys(data).forEach((key) => {
            const [roomIndex, guestIndex, field] = key.split("_");
            const guest =
                newRooms[parseInt(roomIndex)].guests[parseInt(guestIndex)] || {};
            newRooms[parseInt(roomIndex)].guests[
                parseInt(guestIndex)
            ] = Object.assign({}, guest, { [field]: data[key] });
        })

        let bookingInput = {}
        bookingInput.bedSelection = bedSelection
        bookingInput.rooms = newRooms.map((room) => ({
            guests: room.guests.map((guest, i) => ({
                name: guest.first,
                firstName: guest.first,
                lastName: guest.last,
                discountCategory: null,
                email: guest.email,
                phoneNumber: guest.phone,
                meal: guest.meal,
                idType: guest.doc,
                idNumber: guest.passNumber,
                gender: guest.gender.toUpperCase(),
                dateOfBirth: moment(guest.dob).format("YYYY-MM-DD"),
                country: guest.country,
                state: guest.state,
                citizenship: guest.country,
                webCheckinDocType: guest.personalid,
                webCheckinDocNumber: guest.proof,
                webCheckinDocPlace: guest.webCheckinDocPlace,
                webCheckinDocDate: moment(guest.webCheckinDocDate).format("YYYY-MM-DD"),
                passport_address: guest.passportAddress,
                passport_expiry_date: moment(guest.passportExpiryDate).format("YYYY-MM-DD"),
                passport_issue_date: moment(guest.passportIssueDate).format("YYYY-MM-DD"),
                passport_number: guest.passportNumber,
            }))
        }))


        createBookingApi({
            bookingInput
        })
    }

    const createBookingApi = (requestData) => {
        console.log(requestData)
        var inputArray = {
            "bedSelection": requestData.bookingInput.bedSelection,
            "guests": requestData.bookingInput.rooms[0].guests
        }
        return fetch(`${process.env.REACT_APP_API_ENDPOINT}/group_portal/booking_rooms/${dataTable[i].booking_id}`, {
            method: 'PATCH',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${getToken()}`,
            },
            body: JSON.stringify(inputArray)
        }).then((res) => {
            if (res.status === 401) {
                alert("Something went wrong");
                setLoader(false)
            }
            if (res.ok) {
                return res.json();
            } else {
                alert("Something went wrong");
                setLoader(false)
            }
        })
            .then(response => {
                console.log(response)
                if (response?.message == "Guest details succefully updated!") {
                    alert("Data Updated")
                    window.location.reload();
                }
                setLoader(false)
            })
    }

    const handleBedSelection = (value) => {
        setBedSelection(value)
    }


    return (
        <>
            <div className={classes.root}>
                <div className="p-4 grid grid-cols-2">
                    <div>
                        <p className="pl-2 text-sm pb-2">Bed Selection : </p>
                        <button className={bedSelection == "twin_bed" ? styles.bedbutton : styles.unselectedButton} onClick={() => handleBedSelection('twin_bed')}>
                            {bedSelection == "twin_bed" ?
                                <img src={TwinWhite} className={styles.imageStyle} />
                                : <img src={TwinPurple} className={styles.imageStyle} />}
                        </button>
                        <button className={bedSelection == "double" ? styles.bedbutton : styles.unselectedButton} onClick={() => handleBedSelection('double')}>
                            {bedSelection == "double" ?
                                <img src={DoubleWhite} className={styles.imageStyle} />
                                : <img src={DoublePurple} className={styles.imageStyle} />}
                        </button>
                    </div>
                    <div className="flex justify-end">
                        <p className="pr-2 pt-8">No of Guets</p>
                        <select className="bg-white h-8 px-2 w-12 text-black rounded mt-2 focus:outline-non shadow placeholder-j-gray-lighter text-black text-sm self-center pt-1 leading-none border-0 focus:outline-none"
                            value={guetsCount}
                            onChange={(e) => setGuestCount(e.target.value)}>
                            {bedsArray.map((data, i) => {
                                return (
                                    <option value={i + 1}>{i + 1}</option>
                                )
                            })}
                        </select>
                    </div>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    {dataTable[i].rooms.map((r, index) => (
                        <RoomCard
                            key={index}
                            room={r}
                            roomIndex={index}
                            guetsCount={guetsCount}
                            dataTableData={dataTable[i].guest}
                            dataTableLength={dataTable[i].guest.length}
                            // selectedRoom={selectedRoom}
                            errors={errors}
                            register={register}
                            watch={watch}
                            editableStatus={editableStatus}
                            isInternational={isInternational}
                        // tempData={tempData != null ? tempData[i]: null}
                        />
                    ))}
                    <div className="flex justify-center p-4">
                        {!loader ? <input type="submit" className="p-2 w-36 bg-j-orange" value="Update Guest" /> : <div className="opacity-60 flex justify-center p-2 bg-j-white">
                            <ReactLoading type={'bubbles'} color={'#fff'} />
                        </div>}
                    </div>
                </form>
            </div>
        </>
    )
}

const RoomCard = ({ room, roomIndex, errors, register, tempData, selectedRoom, guetsCount, dataTableData, editableStatus, dataTableLength, watch, isInternational }) => {

    console.log(dataTableData)
    console.log(dataTableLength)
    const count = guetsCount;
    const guests = [...(room.guests || Array(count).fill({}))];
    if (guests.length < count)
        guests.push(...Array(count - guests.length).fill({}));
    guests.splice(count);

    const guestForms = guests.map((guest, i) => (
        <GuestForm
            key={i}
            index={i}
            roomIndex={roomIndex}
            errors={errors}
            register={register}
            watch={watch}
            dataTableData={dataTableData[i]}
            dataTableLength={dataTableLength}
            editableStatus={editableStatus}
            isInternational={isInternational}
        />
    ))
    return (
        <>
            <div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-2">
                    {guestForms}
                </div>
            </div>
        </>
    )
}

const GuestForm = ({ index, errors, register, watch, roomIndex, dataTableData, editableStatus, dataTableLength, isInternational }) => {
    const [type, setType] = useState("text");
    const [countryStatesArray, setCountryState] = useState(["Maharashtra", "Tamil Nadu", "Karnataka", "Kerala", "Andaman and Nicobar Islands", "Andhra Pradesh", "Telangana", "Arunachal Pradesh", "Assam", "Bihar", "Chandigarh", "Chhattisgarh", "Dadra and Nagar Haveli", "Daman and Diu", "Delhi", "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jammu and Kashmir", "Jharkhand", "Lakshadweep", "Madhya Pradesh", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Orissa", "Pondicherry", "Punjab", "Rajasthan", "Sikkim", "Tripura", "Uttaranchal", "Uttar Pradesh", "West Bengal"]);
    const [country, setCountry] = useState("India");
    const [phoneCode, setCountryCode] = useState("+91");
    const prefix = `${roomIndex}_${index}`;

    console.log(dataTableData,"dataTableData")
    console.log(dataTableData?.web_checkin_done,"dataTableData.web_checkin_done")
    console.log(index,"index")
    return (
        <>
            <div className={cx("pt-2 pl-3 pr-3")}>
                <p className="pl-2">Guest {index + 1}</p>
                <div>
                    <div className=" grid grid-cols-1">
                        <InputField
                            icon="fal fa-user"
                            placeholder="First name"
                            name={`${prefix}_first_name`}
                            withIcon
                            lessSpace
                            defaultValue={dataTableLength > 0 ? dataTableLength > index
                                ? dataTableData.first_name != "null"
                                    ? dataTableData.first_name
                                    : null
                                : null
                                : null}
                            ref={register({ required: true })}
                            inverseError
                            error={
                                errors && errors[`${prefix}_first_name`] && "Please enter a valid first name"
                            }
                            // disabled={!editableStatus || dataTableLength > 0 ? dataTableLength > index
                            //     ? dataTableData.web_checkin_done != "null"
                            //         ? dataTableData.web_checkin_done
                            //         : false
                            //     : false
                            //     : false}
                            disabled={editableStatus || (dataTableLength > 0 ? true : false)}
                        />
                        <InputField
                            icon="fal fa-user"
                            placeholder="Last name"
                            name={`${prefix}_last_name`}
                            withIcon
                            lessSpace
                            defaultValue={dataTableLength > 0 ? dataTableLength > index ?
                                dataTableData.last_name != null ? dataTableData.last_name : null : null : null}
                            ref={register({ required: true })}
                            inverseError
                            error={
                                errors && errors[`${prefix}_last_name`] && "Please enter a valid last name"
                            }
                            // disabled={!editableStatus || dataTableLength > 0 ? dataTableLength > index
                            //     ? dataTableData.web_checkin_done != "null"
                            //         ? dataTableData.web_checkin_done
                            //         : false
                            //     : false
                            //     : false}
                            disabled={editableStatus || (dataTableLength > 0 ? true : false)}
                        />
                    </div>
                    <div className="pt-4 pl-2">
                        <small className="text-xs pt-12 pb-2 text-j-orange" style={{ position: "relative" }}>*Enter your name as it is mentioned on your Govt. ID Proof</small>
                    </div>
                    <div className="pl-4 pt-4">
                        <RadioField
                            name={`${prefix}_gender`}
                            defaultValue={dataTableLength > 0 ? dataTableLength > index ? dataTableData.gender != null ? dataTableData.gender.toLowerCase() : null : null : null}
                            options={[
                                { value: "female", label: "Female" },
                                { value: "male", label: "Male" },
                            ]}
                            horizontal
                            lessSpace
                            inverseError
                            ref={register({ required: true })}
                            error={errors && errors[`${prefix}_gender`] && "Please select a gender"}
                            // disabled={!editableStatus || dataTableLength > 0 ? dataTableLength > index
                            //     ? dataTableData.web_checkin_done != "null"
                            //         ? dataTableData.web_checkin_done
                            //         : false
                            //     : false
                            //     : false}
                            disabled={editableStatus || (dataTableLength > 0 ? true : false)}
                        />
                    </div>
                    <InputField
                        icon="fal fa-calendar-alt"
                        type="date"
                        onFocus={() => setType("date")}
                        onBlur={() => setType("date")}
                        placeholder="DOB: "
                        max={"9999-12-31"}
                        name={`${prefix}_dob`}
                        withIcon
                        lessSpace
                        defaultValue={dataTableLength > 0 ? dataTableLength > index ? dataTableData.date_of_birth != null ? moment(dataTableData.date_of_birth).format("YYYY-MM-DD") : null : null : null}
                        ref={register({ required: true })}
                        inverseError
                        error={
                            errors &&
                            errors[`${prefix}_dob`] &&
                            `Please enter a valid date`
                        }
                        // disabled={!editableStatus || dataTableLength > 0 ? dataTableLength > index
                        //     ? dataTableData.web_checkin_done != "null"
                        //         ? dataTableData.web_checkin_done
                        //         : false
                        //     : false
                        //     : false}
                        disabled={editableStatus || (dataTableLength > 0 ? true : false)}
                    />
                    <SelectField
                        icon="fal fa-utensils"
                        name={`${prefix}_meal`}
                        withIcon
                        lessSpace
                        placeholder="Choose Meal Type"
                        ref={register({ required: true })}
                        inverseError
                        defaultValue={dataTableLength > 0 ? dataTableLength > index ? dataTableData.meal != null ? dataTableData.meal : null : null : null}
                        error={
                            errors &&
                            errors[`${prefix}_meal`] &&
                            `Please Pick your Meal Preference`
                        }
                        // disabled={!editableStatus || dataTableLength > 0 ? dataTableLength > index
                        //     ? dataTableData.web_checkin_done != "null"
                        //         ? dataTableData.web_checkin_done
                        //         : false
                        //     : false
                        //     : false}
                        disabled={editableStatus || (dataTableLength > 0 ? true : false)}
                    >
                        <option selected value="" disabled>Choose Meal Type</option>
                        <option value="Veg">Vegetarian</option>
                        <option value="Jain">Jain</option>
                        <option value="Non. Veg">Non - Vegetarian</option>
                    </SelectField>
                    <SelectField
                        icon="fal fa-globe"
                        name={`${prefix}_country`}
                        withIcon
                        lessSpace
                        ref={register({ required: true })}
                        defaultValue={dataTableLength > 0 ? dataTableLength > index ? dataTableData.country != null ? dataTableData.country : null : null : null}
                        value={country}
                        onChange={(event) => {
                            let x = event.target.value;
                            setCountry(x);
                            setCountryState(CountryStates.countries.filter((country) => country.country === x)[0].states);
                            setCountryCode(`+${CountryCodes.filter((country) => country.Name === x)[0].Dial}`);
                        }}
                        inverseError
                        error={errors && errors[`${prefix}_country`] && "Please choose"}
                        // disabled={!editableStatus || dataTableLength > 0 ? dataTableLength > index
                        //     ? dataTableData.web_checkin_done != "null"
                        //         ? dataTableData.web_checkin_done
                        //         : false
                        //     : false
                        //     : false}
                        disabled={editableStatus || (dataTableLength > 0 ? true : false)}
                    >
                        {
                            CountryStates.countries.map((country) => {
                                return <option value={country.country} selected>{country.country}</option>
                            })
                        }
                    </SelectField>
                    <SelectField
                        icon="fal fa-building"
                        name={`${prefix}_state`}
                        withIcon
                        lessSpace
                        defaultValue={dataTableLength > 0 ? dataTableLength > index ? dataTableData.state != null ? dataTableData.state : null : null : null}
                        ref={register({ required: true })}
                        inverseError
                        error={errors && errors[`${prefix}_state`] && "Please choose"}
                        // disabled={!editableStatus || dataTableLength > 0 ? dataTableLength > index
                        //     ? dataTableData.web_checkin_done != "null"
                        //         ? dataTableData.web_checkin_done
                        //         : false
                        //     : false
                        //     : false}
                        disabled={editableStatus || (dataTableLength > 0 ? true : false)}
                    >
                        <option selected value={null} disabled>Choose a State</option>
                        {
                            countryStatesArray.map((states) => {
                                return <option value={states}>{states}</option>
                            })
                        }
                    </SelectField>
                    <PhoneField
                        name={`${prefix}_phone`}
                        placeholder="A 10-digit mobile number"
                        ref={register({ required: true })}
                        defaultValue={dataTableLength > 0 ? dataTableLength > index ? dataTableData.phone != null ? dataTableData.phone : null : null : null}
                        countryPhoneCode={phoneCode}
                        lessSpace
                        inverseError
                        error={
                            errors &&
                            errors[`${prefix}_phone`] &&
                            "Please enter a correct phone number"
                        }
                        // disabled={!editableStatus || dataTableLength > 0 ? dataTableLength > index
                        //     ? dataTableData.web_checkin_done != "null"
                        //         ? dataTableData.web_checkin_done
                        //         : false
                        //     : false
                        //     : false}
                        disabled={editableStatus || (dataTableLength > 0 ? true : false)}
                    />
                    <InputField
                        icon="fal fa-envelope"
                        name={`${prefix}_email`}
                        placeholder="Email Address"
                        ref={register({ required: true })}
                        defaultValue={dataTableLength > 0 ? dataTableLength > index ? dataTableData.email != null ? dataTableData.email : null : null : null}
                        lessSpace
                        inverseError
                        error={
                            errors &&
                            errors[`${prefix}_email`] &&
                            "Please enter a valid email"
                        }
                        // disabled={!editableStatus || dataTableLength > 0 ? dataTableLength > index
                        //     ? dataTableData.web_checkin_done != "null"
                        //         ? dataTableData.web_checkin_done
                        //         : false
                        //     : false
                        //     : false}
                        disabled={editableStatus || (dataTableLength > 0 ? true : false)}
                    />
                    <SelectField
                        icon="fal fa-utensils"
                        name={`${prefix}_personalid`}
                        withIcon
                        lessSpace
                        placeholder="Choose ID Type"
                        ref={register({ required: true })}
                        inverseError
                        defaultValue={dataTableLength > 0 ? dataTableLength > index ? dataTableData.web_checkin_doc_type != null ? dataTableData.web_checkin_doc_type : null : null : null}
                        // disabled={!editableStatus || dataTableLength > 0 ? dataTableLength > index
                        //     ? dataTableData.web_checkin_done != "null"
                        //         ? dataTableData.web_checkin_done
                        //         : false
                        //     : false
                        //     : false}
                        disabled={editableStatus || (dataTableLength > 0 ? true : false)}
                        error={errors && errors[`${prefix}_personalid`] && "Please choose"}
                    >
                        <option selected value="" disabled>Choose an ID</option>
                        <option value="aadhar_card">Aadhar</option>
                        <option value="passport">Passport</option>
                        <option value="pan_card">Pan card</option>
                        <option value="election_id">Election ID</option>
                        <option value="driving_license">Driving License</option>
                    </SelectField>
                    <InputField
                        icon="fal fa-envelope"
                        name={`${prefix}_proof`}
                        placeholder="ID Number"
                        defaultValue={dataTableLength > 0 ? dataTableLength > index ? dataTableData.web_checkin_doc_number != null ? dataTableData.web_checkin_doc_number : null : null : null}
                        lessSpace
                        // disabled={!editableStatus || dataTableLength > 0 ? dataTableLength > index
                        //     ? dataTableData.web_checkin_done != "null"
                        //         ? dataTableData.web_checkin_done
                        //         : false
                        //     : false
                        //     : false}
                        disabled={editableStatus || (dataTableLength > 0 ? (dataTableLength > index ? true : false) : false)}
                        ref={register({ required: true })}
                        inverseError
                        error={
                            errors && errors[`${prefix}_proof`] && "Please enter a valid ID"
                        }
                    />
                    {isInternational ?
                        <>
                            <InputField
                                icon="fal fa-calendar-alt"
                                type="date"
                                defaultValue={dataTableLength > 0 ? dataTableLength > index ? dataTableData.passport_issue_date != null ? moment(dataTableData.passport_issue_date).format("YYYY-MM-DD") : null : null : null}
                                onFocus={() => setType("date")}
                                onBlur={() => setType("date")}
                                placeholder="Passport Issue Date: "
                                max={"9999-12-31"}
                                name={`${prefix}_passportIssueDate`}
                                withIcon
                                lessSpace
                                ref={register({ required: true })}
                                inverseError
                                error={
                                    errors &&
                                    errors[`${prefix}_passportIssueDate`] &&
                                    `Please enter a valid date`
                                }
                            />
                            <InputField
                                icon="fal fa-calendar-alt"
                                type="date"
                                defaultValue={dataTableLength > 0 ? dataTableLength > index ? dataTableData.passport_expiry_date != null ? moment(dataTableData.passport_expiry_date).format("YYYY-MM-DD") : null : null : null}
                                onFocus={() => setType("date")}
                                onBlur={() => setType("date")}
                                placeholder="Passport Expiry Date: "
                                max={"9999-12-31"}
                                name={`${prefix}_passportExpiryDate`}
                                withIcon
                                lessSpace
                                ref={register({ required: true })}
                                inverseError
                                error={
                                    errors &&
                                    errors[`${prefix}_passportExpiryDate`] &&
                                    `Please enter a valid date`
                                }
                            />
                            <InputField
                                icon="fal fa-user"
                                placeholder="Passport Number"
                                defaultValue={dataTableLength > 0 ? dataTableLength > index ? dataTableData.passport_number != null ? dataTableData.passport_number : null : null : null}
                                name={`${prefix}_passportNumber`}
                                withIcon
                                lessSpace
                                // defaultValue={tempData != null ? tempData.passportNumber : null}
                                ref={register({ required: true })}
                                inverseError
                                error={
                                    errors && errors[`${prefix}_passportNumber`] && "Please enter passport number"
                                }
                            />
                            <InputField
                                icon="fal fa-user"
                                placeholder="Passport Address"
                                defaultValue={dataTableLength > 0 ? dataTableLength > index ? dataTableData.passport_address != null ? dataTableData.passport_address : null : null : null}
                                name={`${prefix}_passportAddress`}
                                withIcon
                                lessSpace
                                // defaultValue={tempData != null ? tempData.passportAddress : null}
                                ref={register({ required: true })}
                                inverseError
                                error={
                                    errors && errors[`${prefix}_passportAddress`] && "Please enter passport address"
                                }
                            />
                        </>
                        : null
                    }
                    {(watch(`${prefix}_personalid`) === "passport" || (dataTableData && dataTableData.web_checkin_doc_type === "passport")) && <InputField
                        icon="fal fa-envelope"
                        name={`${prefix}_webCheckinDocPlace`}
                        placeholder="Place of issue"
                        defaultValue={dataTableLength > 0 ? dataTableLength > index ? dataTableData.web_checkin_doc_place != null ? dataTableData.web_checkin_doc_place : null : null : null}
                        lessSpace
                        disabled={!editableStatus || dataTableLength > 0 ? dataTableLength > index
                            ? dataTableData.web_checkin_done != "null"
                                ? dataTableData.web_checkin_done
                                : false
                            : false
                            : false}
                        ref={register({ required: false })}

                    />}
                    {(watch(`${prefix}_personalid`) === "passport" || (dataTableData && dataTableData.web_checkin_doc_type) === "passport") &&
                        <InputField
                            icon="fal fa-calendar-alt"
                            type="date"
                            onFocus={() => setType("date")}
                            onBlur={() => setType("date")}
                            placeholder="Issues Date "
                            max={"9999-12-31"}
                            name={`${prefix}_webCheckinDocDate`}
                            withIcon
                            lessSpace
                            defaultValue={dataTableLength > 0 ? dataTableLength > index ? dataTableData.web_checkin_doc_date != null ? moment(dataTableData.web_checkin_doc_date).format("YYYY-MM-DD") : null : null : null}
                            ref={register}
                            disabled={!editableStatus || dataTableLength > 0 ? dataTableLength > index
                                ? dataTableData.web_checkin_done != "null"
                                    ? dataTableData.web_checkin_done
                                    : false
                                : false
                                : false}

                        />
                    }
                    <p className="font-bold">Note :Please proceed to Booking Section, to fill in your health declaration form and complete your web Check-in process. </p>

                    {dataTableLength > index && dataTableLength > 0 && dataTableData.health_declaration_doc_url != "#" && <div className="pl-2">
                        <a href={dataTableData.health_declaration_doc_url} target="_open" className="text-lg text-j-orange underline font-bold">Health Declaration Form</a>
                    </div>}
                    {dataTableLength > index && dataTableLength > 0 && dataTableData.boarding_pass_doc_url != "#" && <div className="pl-2 pt-4 pb-4">
                        <a href={dataTableData.boarding_pass_doc_url} target="_open" className="text-lg text-j-orange underline font-bold">Boarding Pass</a>
                    </div>}
                </div>

            </div>
        </>
    )
}